// extracted by mini-css-extract-plugin
export var alternate = "_1j-j";
export var black = "_1j-6";
export var blue = "_1j-f";
export var blueLight = "_1j-e";
export var brand = "_1j-8";
export var darkMode = "_1j-b";
export var error = "_1j-a";
export var gray = "_1j-5";
export var grayBlue = "_1j-d";
export var iconWrapper = "_1j-3";
export var inactive = "_1j-7";
export var indigo = "_1j-g";
export var orange = "_1j-i";
export var pink = "_1j-h";
export var primary = "_1j-0";
export var purple = "_1j-9";
export var success = "_1j-4";
export var warning = "_1j-c";
export var white = "_1j-1";
export var whiteSuccess = "_1j-2";